import { MarketingAllBenefits } from "../../../components/MarketingAllBenefits";
import { MarketingFooter } from "../../../components/MarketingFooter";
import { MarketingGetStarted } from "../../../components/MarketingGetStarted";
import { MarketingMenu } from "../../../components/MarketingMenu";
import { MarketingOGTags } from "../../../components/MarketingOGTags";
import { MarketingTextSVGColumn } from "../../../components/MarketingTextSVGColumn";
import { MarketingTextSVGHeader, CurateContentSVGDesktop, MarketingTextSVGCTA } from "../../../components/MarketingTextSVGHeader";
import { MarketingUserPledge } from "../../../components/MarketingUserPledge";
import { FadeUpContainer } from "../../../components/ReusableStyledComponents/FadeUp";
import { MarketingTitleBr } from "../../../components/ReusableStyledComponents/MarketingMainTitle";
import { VerticalSpacing } from "../../../components/VerticalSpacing";
import { theme } from "../../../theme/theme";
import { APPLICATION_ROUTES } from "../../../shared-logic/routes";

export const CollectionsMarketingPageLayout = () => {
    return (
        <>
            <MarketingOGTags
                title="Authory – Start organizing your content now"
                description="Easily combine different content pieces and turn them into beautiful collections."
                canonicalUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}${APPLICATION_ROUTES.COLLECTIONS_MARKETING}`}
            />
            <MarketingMenu />
            <FadeUpContainer>
                <VerticalSpacing
                    top={0}
                    breakpoints={[
                        { screen: theme.breakpoints.tablet, marginTop: 20 },
                        { screen: theme.breakpoints.desktop, marginTop: 70 }
                    ]}
                >
                    <MarketingTextSVGHeader
                        subtitle="Collections"
                        title={
                            <>
                                <strong>Organize all your content</strong> <MarketingTitleBr /> with a few clicks
                            </>
                        }
                        description={
                            <>
                                <strong>Before:</strong> Grouping different content pieces together is a nightmare that requires various 3rd party
                                services. <strong>After:</strong> Curate your content in beautiful collections. You decide whether to curate based on
                                topic, type of content, publication or anything else - and if you wish it's all automated.
                                <MarketingTextSVGCTA text="Start organizing your content now" />
                            </>
                        }
                        desktopSVG={<CurateContentSVGDesktop />}
                        mobileSVG={<img src="/authory_static_files/images/features/curate/curate_header_mobile.png" />}
                        textMaxWidth={900}
                        containerMaxWidth={1420}
                        descriptionTextMaxWidth={800}
                        desktopImage={"/authory_static_files/images/features/curate/curate_header_desktop.png"}
                        desktopImageWidth={1218}
                        desktopImageHeight={599}
                        desktopImageMarginTop={280}
                        mobileMaxWidth={377}
                    />
                </VerticalSpacing>
                <VerticalSpacing top={120} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 180 }]}>
                    <MarketingTextSVGColumn
                        subtitle={"Powerful collections"}
                        title={
                            <>
                                <strong>Fully automated</strong>
                                <br />
                                or by hand
                            </>
                        }
                        description={
                            <>
                                Thanks to Authory's automated rules you can populate Collections in no time. Yet you have full control at any time: If
                                you don't find the right rule you can always manually add content, too.
                            </>
                        }
                        desktopImgWidth={800}
                        desktopImgHeight={346}
                        desktopImage={"/authory_static_files/images/features/curate/automated_desktop.png"}
                        mobileImage={"/authory_static_files/images/features/curate/automated_mobile.png"}
                        snapBr={1360}
                        mobileMaxWidth={359}
                    />
                </VerticalSpacing>
                <VerticalSpacing top={120} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 180 }]}>
                    <MarketingTextSVGColumn
                        subtitle={"Flexible visibility"}
                        title={
                            <>
                                <strong>Curating for yourself</strong>
                                <br /> or the world to see
                            </>
                        }
                        description={
                            <>
                                Thanks to Authory's automated rules you can populate Collections in no time. Yet you have full control at any time: If
                                you don't find the right rule you can always manually add content, too.
                            </>
                        }
                        svgPosition="left"
                        desktopImgWidth={720}
                        desktopImgHeight={309}
                        desktopImage={"/authory_static_files/images/features/curate/curating_desktop.png"}
                        mobileImage={"/authory_static_files/images/features/curate/curating_mobile.png"}
                        snapBr={1290}
                        mobileMaxWidth={343}
                    />
                </VerticalSpacing>
                <VerticalSpacing top={120} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 180 }]}>
                    <MarketingTextSVGColumn
                        subtitle={"Custom share links"}
                        title={
                            <>
                                <strong>Sharing</strong> has never been easier
                            </>
                        }
                        description={
                            <>
                                Every Collection comes with a private Share link, enabling you to show your curated content to specific people only,
                                and taking the access back anytime.
                            </>
                        }
                        desktopImgWidth={669}
                        desktopImgHeight={521}
                        desktopImage={"/authory_static_files/images/features/curate/sharing_desktop.png"}
                        mobileImage={"/authory_static_files/images/features/curate/sharing_mobile.png"}
                        snapBr={1235}
                        mobileMaxWidth={358}
                    />
                </VerticalSpacing>
                <VerticalSpacing top={120} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 180 }]}>
                    <MarketingTextSVGColumn
                        subtitle={"Custom RSS feeds"}
                        title={
                            <>
                                Ready to be <br />
                                <strong>used elsewhere</strong>
                            </>
                        }
                        description={
                            <>
                                Your Collections come with a custom RSS feed, enabling you to use your curated content however you like: On your own
                                website, in a widget, with an RSS reader. The options are endless.
                            </>
                        }
                        svgPosition="left"
                        desktopImgWidth={656}
                        desktopImgHeight={332}
                        desktopImage={"/authory_static_files/images/features/curate/ready_desktop.png"}
                        mobileImage={"/authory_static_files/images/features/curate/ready_mobile.png"}
                        snapBr={1240}
                        mobileMaxWidth={377}
                    />
                </VerticalSpacing>
                <VerticalSpacing top={120} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 180 }]}>
                    <MarketingTextSVGColumn
                        subtitle={"Your articles, podcasts and videos"}
                        title={
                            <>
                                Combine from all your <strong>different channels and formats</strong>
                            </>
                        }
                        description={
                            <>
                                No matter what type of content, no matter where it's been published, with your Authory Collections you can combine
                                different content pieces and turn them into something new, proving how your content is truly multi-channel.
                            </>
                        }
                        desktopImgWidth={572}
                        desktopImgHeight={381}
                        desktopImage={"/authory_static_files/images/features/curate/combine_desktop.png"}
                        mobileImage={"/authory_static_files/images/features/curate/combine_mobile.png"}
                        mobileMaxWidth={360}
                    />
                </VerticalSpacing>
                <VerticalSpacing top={120} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 180 }]}>
                    <MarketingUserPledge
                        title={
                            <>
                                “Authory transformed a folder of PDFs and links into a single, searchable repository.{" "}
                                <strong>It's an absolute game-changer.</strong>”
                            </>
                        }
                        description={
                            <>
                                <strong>Gabriel Swain,</strong> Insightly, Agile CRM and more
                            </>
                        }
                        avatarImage={"/authory_static_files/images/pledges/Gabriel.jpg"}
                    />
                </VerticalSpacing>
                <VerticalSpacing top={120}>
                    <MarketingGetStarted />
                </VerticalSpacing>
                <MarketingAllBenefits currRoute={APPLICATION_ROUTES.COLLECTIONS_MARKETING} />
                <MarketingFooter backgroundColor="white" />
            </FadeUpContainer>
        </>
    );
};
